/* ============================================================
   Dathent — screenPath.js (TASK-196, issue #315)
   The ONE screen-path normalizer for analytics. Used by lib/funnel.js for
   every event's `path` and by components/ScreenTraceBridge.jsx for the
   screen_view / first_action / screen_exit_no_action screen names, so
   the admin behaviour dashboard can group both by the same key.

   Takes a PATHNAME only — never pass location.search: the SPA's URLs
   carry ?token= (Auth reset/verify), ?session_id= (Stripe return) and the
   OAuth return params (provider/connected/accounts/error), none of which
   may reach an analytics table.
   ============================================================ */

// /app/post/123/edit -> post/:id/edit ; /app -> dashboard
export function normalizeScreen(pathname) {
  const p = String(pathname || '')
    .replace(/^\/app\/?/, '')
    .replace(/\/+$/, '');
  if (!p) return 'dashboard';
  return p
    .split('/')
    .map((seg) => (/^[0-9]+$/.test(seg) || /^[a-z]+_[A-Za-z0-9]{8,}$/.test(seg) || /^[0-9a-f-]{16,}$/.test(seg) ? ':id' : seg))
    .join('/');
}
